module.exports = __webpack_public_path__ + "static/media/spot-dino.623825d8.svg";